import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/LandingPage.css";

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      <nav className="navbar">
        <div className="landing-logo">TOEICMON</div>
        <button className="login-button" onClick={() => navigate("/login")}>
          Login
        </button>
      </nav>

      <div className="landing-sections">
        <section className="landing-section">
          <div className="image-container">
            <img
              src={`${process.env.PUBLIC_URL}/images/landing/landing1.png`}
              alt="Landing section 1"
              className="landing-image"
              onError={(e) => {
                console.log("이미지 로드 실패");
                console.log("시도한 경로:", e.target.src);
              }}
            />
          </div>
        </section>
        <section className="landing-section">
          <div className="image-container">
            <img
              src={process.env.PUBLIC_URL + "/images/landing/landing2.png"}
              alt="Landing section 2"
              className="landing-image"
            />
            <button
              className="start-button"
              onClick={() => navigate("/signup")}
            >
              지금 시작하기
            </button>
          </div>
        </section>
        <section className="landing-section">
          <div className="image-container">
            <img
              src={process.env.PUBLIC_URL + "/images/landing/landing3.png"}
              alt="Landing section 3"
              className="landing-image"
            />
          </div>
        </section>
        {/* 추가 섹션들은 이미지가 준비되면 같은 형식으로 추가하시면 됩니다 */}
      </div>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <p className="footer-text">© 2024. All rights reserved.</p>
            <p className="footer-text">Email: support@toeicmon.com</p>
          </div>
          <div className="footer-menu">
            <div className="footer-menu-column">
              <h3 className="footer-menu-title">Pricing</h3>
              <a href="/plans" className="footer-link">
                Plans
              </a>
            </div>
            <div className="footer-menu-column">
              <h3 className="footer-menu-title">Legal</h3>
              <a href="/terms" className="footer-link">
                Terms of Use
              </a>
              <a href="/licensing" className="footer-link">
                Licensing
              </a>
              <a href="/privacy" className="footer-link">
                Privacy Policy
              </a>
              <a href="/cancellation" className="footer-link">
                Cancellation Policy
              </a>
            </div>
            <div className="footer-menu-column">
              <h3 className="footer-menu-title">Company</h3>
              <a href="/about" className="footer-link">
                About
              </a>
            </div>
            <div className="footer-menu-column">
              <h3 className="footer-menu-title">Support</h3>
              <a href="/help" className="footer-link">
                Help Center
              </a>
              <a href="/contact" className="footer-link">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
